import classNames from 'classnames';
import { SliceComponentProps } from '@prismicio/react';
import { asText, Content, isFilled } from '@prismicio/client';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';

import { Box, Wrapper, Heading, Typography } from '@preventx/oxygen';

// Services
import { wrapperSize } from '@/services/utils/box';

// Components
import { Link } from '@/components/Actions/Link';
import { BaseProductsContainer } from '@/slices/shared/Products/BaseProductsContainer';
import { WithDetailsSimpleProducts } from '@/slices/shared/Products/WithDetailsSimpleProducts';
import { WithFeaturedProductsContainer } from '@/slices/shared/Products/WithFeaturedProductsContainer';

export type ProductsProps = SliceComponentProps<Content.ProductsSlice>;

const Products = ({ slice }: ProductsProps) => {
  const { id, primary, variation } = slice;
  const {
    title,
    caption,
    products,
    identifier,
    wrapper_size,
    products_link,
    override_padding,
  } = primary;

  return (
    <Box
      addRegion
      component="section"
      id={isFilled.keyText(identifier) ? identifier : undefined}
      className={classNames('region--products', {
        'pt-0': override_padding === 'No Padding - Top',
        'pb-0': override_padding === 'No Padding - Bottom',
        'py-0': override_padding === 'No Padding - Top Bottom',
      })}
    >
      <Wrapper size={wrapperSize(wrapper_size)} addFlow>
        <Box
          addRepel
          component="div"
          className={classNames('headline items-end', {
            'pb-0': variation === 'withFeatureCardProducts',
          })}
        >
          <Box component="div" addFlow>
            <Heading component="h2" addHeadlineTitle>
              {asText(title)}
            </Heading>

            {isFilled.richText(caption) && (
              <Typography component="p" className="headline__sub">
                {asText(caption)}
              </Typography>
            )}
          </Box>

          {isFilled.link(products_link) && (
            <Link
              as="default"
              type="button"
              colour="primary"
              variant="outline"
              retainSearchParams
              href={products_link}
              icon={{
                position: 'right',
                definition: faArrowRight,
                addDirectionalIcon: true,
              }}
            >
              {products_link.text}
            </Link>
          )}
        </Box>

        {variation === 'default' && (
          <BaseProductsContainer
            sliceId={id}
            addRegion={false}
            products={products}
            displayImage={primary.display_product_images}
          />
        )}

        {variation === 'withDetailsSimpleProducts' && (
          <WithDetailsSimpleProducts slice={slice} sliceId={id} />
        )}

        {variation === 'withFeatureCardProducts' && (
          <WithFeaturedProductsContainer sliceId={id} products={products} />
        )}
      </Wrapper>
    </Box>
  );
};

export default Products;
